export const MOBILE_VERSIONS = {
    MOBILE_ASSET: "MOBILE_ASSET",
    MOBILE_BACKGROUND_GIF: "MOBILE_BACKGROUND_GIF"
};
